'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondsAgo.js
// module id = 736
// module chunks = 0